import { FunctionalComponent, h } from "@stencil/core";
import { tableClass } from "../constants";

interface TableCellProps {
    group?: boolean;
    empty?: boolean;
    sort?: string;
    multiline?: boolean;
}

export const TableDataCell: FunctionalComponent<TableCellProps> = (
    { group = false, empty = false, sort = null, multiline = false },
    children
) => (
    <td
        class={{
            [`${tableClass}__td`]: true,
            [`${tableClass}__td--multiline`]: multiline
        }}
        data-sort={sort}
    >
        <div
            class={{
                [`${tableClass}__cell`]: true,
                [`${tableClass}__cell--no-data`]: empty,
                [`${tableClass}__cell--group`]: group
            }}
        >
            {children}
        </div>
    </td>
);
